// will be eventually replaced by ES8 -> export default from './filename';
// see: https://github.com/leebyron/ecmascript-export-default-from
import Component from './authentication-form';
export default Component;
export * from './authentication-form';
